var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDjango(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 63,
    viewBox: "0 0 49 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3209 0H32.6168V47.6619C27.335 48.6642 23.457 49.0656 19.2458 49.0656C6.675 49.0656 0.123291 43.3824 0.123291 32.483C0.123291 21.9851 7.07644 15.1657 17.842 15.1657C19.5134 15.1657 20.7833 15.2996 22.3209 15.701V0ZM22.3209 23.9897C21.2017 23.6116 20.0254 23.4305 18.8443 23.4544C13.6281 23.4544 10.6212 26.6634 10.6212 32.281C10.6212 37.7648 13.497 40.7717 18.7787 40.7717C19.9148 40.7717 20.8516 40.7061 22.3209 40.5041V23.9897ZM49 15.9004V39.7694C49 47.9925 48.3991 51.9387 46.5939 55.3471C44.9226 58.6242 42.7159 60.6971 38.1688 62.9693L28.6076 58.4222C33.1547 56.2838 35.3613 54.4104 36.7651 51.5347C38.237 48.5933 38.7041 45.1824 38.7041 36.2246V15.8978L49 15.9004ZM38.7041 0.0551004H49V10.6186H38.7041V0.0551004Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjango);
export default __webpack_public_path__ + "static/media/django.f527c7ae38e434dc18d684ff6fc330e5.svg";
export { ForwardRef as ReactComponent };